import { useContext } from 'react';
import FormWizardContext, { FormWizard } from '../contexts/form-wizard-context';

const useFormWizardContext: () => FormWizard = () => useContext(FormWizardContext);

export default useFormWizardContext;